import { styled } from '@mui/material';
import { Box } from 'shared/mui/Box';

export const BoxStyled = styled(Box)({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: 'inline',
});
